import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { Form } from "react-final-form";
import { useAuthProvider, useRedirect, useNotify } from "react-admin";
import AppBar from "../../Components/header/AuthenticationPageHeader";
import AppProvider from "../../Components/bootstrap/index";
import { useRouteState } from "./../../Utils/hooks";
import { SignUpForm } from "./Signup";
import CertificationDialog from "./AddCertification"
import { Route } from 'react-router-dom';
import { Parse } from "./../../Utils/parseDataProvider";

const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {

    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: 10,
    width: 300,
    height: 60,
    // margin: theme.spacing(1),
    backgroundColor: "white"
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  coverBackgroundContainer: {
    backgroundColor: "#F7F8F9",
    height: "100%",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: "4%",
    paddingRight: "4%",
    paddingTop: "90px",
    paddingBottom: "20px"
  }
}));

const SignUp = props => {
  const authProvider = useAuthProvider();
  const location = useRouteState();
  const isMentor = location.pathname.includes("/signup/mentor");
  const classes = useStyles();
  const redirect = useRedirect();
  const { signUpGoogle } = useAuthProvider();
  const notify = useNotify();

  useEffect(() => {
    if (location.query && location.query.state === "linkedinInLogin") {
      authProvider.signUpLinkedIn({ code: location.query.code });
      if (isMentor) {
        return redirect("/paymentdetails");
      } else {
        return redirect("/");
      }
    }
  }, [authProvider, location, redirect, isMentor]);

  return (
    <div className={classes.coverBackgroundContainer}>
      <Route path="/signup/:user/add-certification" component={CertificationDialog} noLayout />
      <AppProvider>
        <Container
          component="main"
          maxWidth="sm"
          style={{ background: "#ffffff", marginBottom: "2%" }}
        >
          <AppBar />
          <Typography
            component="h6"
            variant="h6"
            style={{ paddingTop: "10%" }}
          >
            Register for 123Mentor
            </Typography>

          <Form
            initialValues={{
              isMentor
            }}
            // validate={validateSignUpForm}
            onSubmit={async response => {

              const profileImagePromise = response.image
                ? new Parse.File(
                  response.image.rawFile.name,
                  response.image.rawFile
                )
                : null;
              const profileImage = profileImagePromise
                ? await profileImagePromise.save()
                : null;
              const ApiResponse = await authProvider.signUp({
                ...response,
                profileImage,
              });
              const MainResponse = JSON.parse(ApiResponse);
              if (MainResponse.code !== 202) {
                if (isMentor) {
                  return redirect("/paymentdetails");
                }
                return redirect("/");
              } else {
                notify(MainResponse.message);

              }

            }}
            signUpGoogle={async payload => {
              try {
                await signUpGoogle({ payload, notify, redirect, isMentor });
                if (isMentor) {
                  return redirect("/paymentdetails");
                }
                return redirect("/");
              } catch (e) {
                notify("Could not login to google");
              }
            }}
            signUpGoogleFailure={async e => {
              notify("Could not login to google");
            }}
            keepDirtyOnReinitialize
            render={SignUpForm}
          />
        </Container>
      </AppProvider>
    </div>
  );
};
export default SignUp;
